(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleExclusionDialogController', MonitoringRuleExclusionDialogController);

    MonitoringRuleExclusionDialogController.$inject = ['$scope', '$uibModalInstance', 'entity', 'historyContext', 'MonitoringRuleTemporaryExclusion'];

    function MonitoringRuleExclusionDialogController($scope, $uibModalInstance, entity, historyContext, MonitoringRuleTemporaryExclusion) {
        var vm = this;
        vm.exclusion = entity;
        vm.historyContext = historyContext;
        vm.markAsProcessed = !!(historyContext && historyContext.uuidExecution);
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.exclusion.id) {
                MonitoringRuleTemporaryExclusion.update(vm.exclusion, onSaveSuccess, onSaveError);
            } else {
                MonitoringRuleTemporaryExclusion.save(vm.exclusion, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:monitoringRuleExclusionUpdate', result);
            $uibModalInstance.close({
                exclusion: result,
                markAsProcessed: vm.markAsProcessed,
                uuidExecution: historyContext ? historyContext.uuidExecution : null
            });
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
